define.alias("shared/components/shared/plan-recommendation/steps/role", "preview-grid/components/shared/plan-recommendation/steps/role");